<script lang="ts">
  import type { Api } from "../lib/api";
  import UserManager from "./users/UserManager.svelte";

  let { api }: { api: Api } = $props();
</script>

<div class="flex flex-col gap-5">
  <p class="m-0 text-sm text-muted leading-normal">
    <strong class="text-ink font-bold">Portal admins</strong> sign into this owner console.
    App users sign into the desktop app and are managed under
    <strong class="text-ink font-bold">Organizations</strong> — they are separate accounts.
  </p>

  <UserManager {api} role="portal" />
</div>
